import { SelectOption } from '@tryhackme/thm-ui-components';

import { RoomStatus } from 'src/common/enums/rooms';

export const ADMIN_SUBMISSIONS_URL = '/admin/submissions';

export const SelectOptions = [
  {
    id: '1',
    value: '10',
    label: '10',
  },
  {
    id: '2',
    value: '25',
    label: '25',
  },
  {
    id: '3',
    value: '100',
    label: '100',
  },
];

export const SelectedStatus = [
  {
    id: '1',
    value: '',
    label: 'All Submissions',
  },
  {
    id: '2',
    value: RoomStatus.SUBMITTED,
    label: 'Submitted',
  },
  {
    id: '3',
    value: RoomStatus.EVALUATING,
    label: 'Evaluating',
  },
  {
    id: '4',
    value: RoomStatus.READY,
    label: 'Ready',
  },
  {
    id: '5',
    value: RoomStatus.ACCEPTED,
    label: 'Accepted',
  },
  {
    id: '6',
    value: RoomStatus.REJECTED,
    label: 'Rejected',
  },
];

export const ScheduleRoomErrorMessage = 'Uh-oh! You can’t schedule a room that isn’t ready';

export const defaultOption: SelectOption = { id: '1', value: '10', label: '10' };
export const defaultTesterOption: SelectOption = { id: '1', value: 'All Testers', label: 'All Testers' };
export const defaultSubmissionsOption: SelectOption = { id: '1', value: 'All Submissions', label: 'All Submissions' };

export const validSortValues = [
  '-code',
  '-userId',
  '-type',
  '-checked.userId',
  '-checked.requested',
  '-checked.status',
  '-checked.scheduled',
];
